import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SEARCH_PRODUCTS, SEARCH_PRODUCTS_FAIL, SEARCH_PRODUCTS_SUCCESS } from './product-aux.actions';
import { map } from 'rxjs';
import { LoaderService } from '../../../../../components/loader/loader.service';
import { LOADER_TYPE } from '../../../../../components/loader/loader.model';

@Injectable()
export class ProductAuxEffects {
  constructor(
    private actions$: Actions,
    private loaderService: LoaderService,
  ) {}

  loadProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SEARCH_PRODUCTS, SEARCH_PRODUCTS_SUCCESS, SEARCH_PRODUCTS_FAIL),
      map((action: { type: string }) => {
        this.loaderService.init({
          status: action.type === SEARCH_PRODUCTS,
          type: LOADER_TYPE.INFINITE,
        });

        return { type: '[Loader] - ' + action.type };
      }),
    ),
  );
}
